import { render, staticRenderFns } from "./conges-credit-debit-list-item.vue?vue&type=template&id=87b25bca&scoped=true"
import script from "./conges-credit-debit-list-item.vue?vue&type=script&lang=js"
export * from "./conges-credit-debit-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b25bca",
  null
  
)

export default component.exports